(function (w, $, _) {
    $(function () {
        const defaultBarTemplate = '' +
            '<% if (cookiePolicy.show || privacyPolicy.show) { %>' +
            '<div id="cookie-bar" class="site-cookie-bar js-agreements-bar site-cookie-bar_<%= settings.position %>">' +
                '<div class="site-cookie-bar__line1">' +
                    '<i class="site-cookie-bar__shield-icon fa fa-shield"></i>&nbsp;' +
                    '<span><%- labels.agreementsThirdPartyUsageMsg %></span>' + 
                '</div>' +
                '<div class="site-cookie-bar__line2">' +
                    '<span><%- (cookiePolicy.changed || privacyPolicy.changed ? labels.changedAgreementsMessage : labels.intialAgreementsMessage) %></span>' +
                    '<% if (cookiePolicy.show) { %>' +
                    '&nbsp;<a class="site-cookie-bar__policy-link" href="<%= settings.appRoot %>ViewPolicyDocument.aspx?docid=CookiePolicy&showaccept=true" target="_blank"><%- labels.cookiePolicy %></a>' +
                    '<% } %>' +
                    '<% if (privacyPolicy.show) { %>' +
                        '<% if (cookiePolicy.show) { %>' +
                        '&nbsp;<%- labels.and %>' +
                        '<% } %>' +
                    '&nbsp;<a class="site-cookie-bar__policy-link" href="<%= settings.appRoot %>ViewPolicyDocument.aspx?docid=EndUserPrivacyPolicy&showaccept=true" target="_blank"><%- labels.privacyPolicy %></a>' +
                    '<% } %>' +
                    '&nbsp;<button type="button" class="site-cookie-bar__btn js-accept-agreements"><%- labels.understand %></a>' +
                '</div>' +
            '</div>' +
            '<% } %>';

        const assetId = '~/js/jquery.end_user_agreement_bar.min.js';

        if (!w.umwAssets || !w.umwAssets[assetId]) {
            console.error('No context found for ' + assetId);
            return;
        }

        const ctx = w.umwAssets[assetId][0];

        if (ctx) {
            const template = w.agreementsBarTemplateOverride || defaultBarTemplate;

            const barHtml = _.template(template, ctx);

            if (barHtml) {
                $('body').prepend(barHtml);

                const $bar = $('.js-agreements-bar');

                $('.js-accept-agreements').on('click', function (evt) {
                    $bar.remove();
                    _setAgreementsAccepted();
                });
            }

            function _setAgreementsAccepted() {
                $.ajax({
                    url: w.R + 'handlers/public/userdata.ashx',
                    type: 'POST',
                    data: {
                        'action': 'SetEndUserAgreementsAccepted'
                    },
                    dataType: 'json',
                });
            }
        }
    });
})(window, jQuery, _);